import { type Context, useContext } from 'react';

/** Use a context value, throwing an error if it's not defined. */
export function useRequiredContext<T>(
	context: Context<T | undefined>,
	contextName: string,
): T {
	const ctx = useContext(context);
	if (!ctx) {
		throw new Error(`${contextName} requires its matching provider`);
	}
	return ctx;
}
